/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import classnames from 'classnames';

import TextInput from './TextInput';

const TextInputWithMargin = (props) => {
  return (
    <TextInput
      className={classnames('with-margin', props.className)}
      {...props}
    />
  );
}

export default TextInputWithMargin;
